//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import orderAvailable from "@/components/orderAvailable.vue";
import SelectPayDialog from "@/components/base/selectPayDialog.vue";
import { SERVER } from "@/api/apiConfig";
import { Dialog } from "vant";
import { SHA1 } from "@/utils/sha1";
import { Encrypt, Decrypt } from "@/utils/aes.js";
import loginFun from "@/utils/cc-webapp/login.js";
export default {
  name: "buy",
  components: {
    orderAvailable,
    SelectPayDialog,
  },
  data() {
    return {
      imgbg1: require("@/assets/image/photo/bg1.png"),
      objType: null, // 资源类型: media/medialist/pack
      id: "",
      pageData: {
        buyMethods: [
          {
            salePrice: null,
          },
        ],
        product: {},
        suggest: {},
      }, //商品詳情
      account: {},
      // canBuy: false,
      isNative: false,
      useCoupon: {
        id: 0,
        money: 0,
        discount: 0,
        useType: -1,
      }, // 使用的優惠券  -1 為不使用
      realMoney: 0, // bar實付款
      discountMoney: 0, //優惠價格
      activityMoney: 0, //活動價格
      isActivity: 3, //是否顯示秒殺標識  0 秒殺 1 會員  2秒殺會員  3價格
      isbuyType: 0, //不顯示  0參加活動  1 不參加
      // couponList: [], //當前購買模式下優惠券
      buyMethods: {}, //當前購買模式參數
      couponId: null, //優惠券id 默認選中
      activityId: "", //促銷活動id 0不參加
      showSuggest: false, // 是否顯示購買建議
      isBuy: false,
      imgNull: require("@/assets/image/icon/icon_null.png"),
      errData: {
        code: false,
      },
      integral: 1055,
      intChecked: false,
      payType: "cash",
      payList: ["alipay", "wechat"], //支付方式
      payData: {
        cash: 0,
      },
      selectPayDialog: false,
      orderId: "",
      priceRate: 1,
      columnCode: "",
      priceLabel: "",
      showForm: false,
      payMethod: "CC",
      paymentType: "N",
      currencyCode: "344",
      isLogin: false,
      reUrl: null,
      retry:0,
      paydollar_key: null,
      signHashCode:"",
    };
  },
  methods: {
    onClickLeft() {
      //this.$router.go(-1)
      try {
        if(this.retry == 1){
          this.$routerHelper.goPageByThird('home')
        }else{
          this.$router.go(-1);
        }
        let isIos =
          /iPad|iPhone|iPod|ios/.test(navigator.userAgent) && !window.MSStream;
        if (isIos) {
          window.webkit.messageHandlers.onExitPage.postMessage({ page: "buy" });
        } else {
          window.AndroidInterface.onExitPage();
        }
      } catch (error) {
        console.log(error);
      }
    },
    getData() {
      this.UTILS.showLoadingText();
      console.log(this.id, this.objType, this.LOGIN2.getThirdPartToken());
      let postD = {
        id: this.id,
        objType: this.objType,
        appId: this.SERVER.APPID,
        extData: this.LOGIN2.getThirdPartToken(),
      };
      this.LOGIN2.getSession("no login")
        .then((returnSession) => {
          this.GLOBAL_.ccRequest
            .doSessionAxios(
              this.CONFIG.H5BUY.GET_BUY_OBJECT,
              postD,
              "GET",
              "no login"
            )
            .then((resp) => {
              this.UTILS.hideLoading();
              var res = (this.pageData = resp.data); //商品詳情
              this.activityMoney = res.product.salePrice;
              // this.buyMethods = [];
              this.buyMethods = res.buyMethods;
              this.priceRate = res.product.priceRate;
              this.priceLabel = res.product.priceLabel;
              if (res.extInfo) {
                this.account.amount = res.extInfo.userPointAvailable;
              }
              this.columnCode = res.product.columnCode;
              // console.log("======>購買方", res);

              //默認第一個購買方式
              this.isbuyType = 0;
              if (this.couponId == null) {
                //无论活动还是其他直接选择
                if (res.suggest != null && this.isbuyType != res.suggest) {
                  this.buyType(res.suggest);
                } else {
                  this.buyType(0);
                }
              } else {
                this.gteUseCoupon(res);
              }

              //如果有購買建議，且購買建議不是活動的時候，顯示購買建議
              if (res.suggest != null && res.suggest != this.isbuyType) {
                this.showSuggest = true;
              }

              // console.log("======>isbuyType", this.isbuyType);
              // console.log("======>showSuggest", this.showSuggest);
            })
            .then(() => {
              // this.getAccountInfo();
            })
            .catch((err) => {
              this.UTILS.hideLoading();

              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.errData = err.response.data;
                if (err.response.data.code == 400) {
                }
              }
              // native.showToast(this.$t("BUY_LANG.getGoodsDataFail") + status);
            });
        })
        .catch((err) => {
          this.UTILS.hideLoading();
          console.log(err);
        });
    },
    //使用優惠券時默認選中該優惠券
    gteUseCoupon(data) {
      // console.log(this.couponId,data,"使用優惠券時默認選中該優惠券");
      for (let i = 0; i < data.buyMethods.length; i++) {
        if (data.buyMethods[i].discount == this.couponId) {
          this.isbuyType = i;
          this.price(data, i);
          // console.log("購買方式===>",i)
        }
      }
    },
    //購買價格方式切換
    price(res, n) {
      // console.log("======>購買方式", res.buyMethods[n]);
      //商品活動價格
      if (this.couponId == null) {
        this.couponId = res.buyMethods[n].discount;
      }
      this.activityId = res.buyMethods[n].activityId;

      // console.log("couponList=>", this.couponList);

      //是否顯示秒殺會員標識
      if (res.buyMethods[n].activityId > 0) {
        //有活動
        if (res.buyMethods[n].discount < 1) {
          //有活動，且會員有折扣
          this.isActivity = 2;
        } else {
          this.isActivity = 0;
        }
      } else {
        //沒有活動，但會員折扣
        if (res.buyMethods[n].discount < 1) {
          this.isActivity = 1;
        }
      }
    },
    //監控優惠券傳遞使用的優惠券對象
    getProject(e) {
      if (e) {
        this.couponId = e.discount;
        // this.realMoney = this.activityMoney - e.discount;
        this.realMoney = e.salePrice;
        this.useCoupon = e;
      } else {
        this.realMoney = this.pageData.product.salePrice;
      }
      this.discountMoney = this.pageData.product.price - this.realMoney;
      // console.log("getProject", e);
    },
    //切換購買方式

    buyType(n) {
      this.price(this.pageData, n);
      this.isbuyType = n;
    },

    //獲取知書幣賬戶餘額
    getAccountInfo() {
      let postD = {};
      this.LOGIN2.getSession("no login")
        .then((returnSession) => {
          this.GLOBAL_.ccRequest
            .doSessionAxios(
              this.CONFIG.USER.GETCOINACCOUNTINFO,
              postD,
              "GET",
              "no login"
            )
            .then((res) => {
              this.account = res;
              //判斷餘額是否足夠
              // if (res.amount - res.frozenAmount < this.pageData.salePrice) {
              // if (res.amount - res.frozenAmount < this.realMoney) {
              //   this.canBuy = false;
              // } else {
              //   this.canBuy = true;
              // }
            })
            .catch((err) => {
              this.UTILS.showToast(
                this.$t("BUY_LANG.getUsersAccountDataFail") + status
              );
              this.UTILS.hideLoading();
            });
        })
        .catch((err) => {
          // console.log(err);
          //沒有session
        });
    },
    doH5Buy() {
      console.log("doH5Buy", this.realMoney);
      //可以全额积分直接抵扣
      let isFullCost = this.realMoney <= 0;
      if (isFullCost) {
        //直接下单后调用结果回调
        this.payType = "cash";
        this.createPayOrder(isFullCost);
      } else {
        //调起支付
        this.payData = {
          cash: this.UTILS.formatPriceH5(this.realMoney),
        };
        this.selectPayDialog = true;
        // this.UTILS.showToast(this.$t('BUY_LANG.integralFail'))
      }
    },
    createPayOrder(isFullCost) {
      this.UTILS.showLoadingText();
      let url = this.CONFIG.H5BUY.BUY;
      let postD = {
        payType: this.payType,
        coin: isFullCost ? 0 : this.realMoney,
        clientType: "H5",
        customerData: "", //this.config[this.selectedIdx].coin,
        id: this.id,
        objType: this.objType, //"medialist", //media/medialist/pack
        templateId: this.templateId,
        discountPrice: this.couponId,
        // extData:this.LOGIN2.getThirdPartToken()
      };
      this.GLOBAL_.ccRequest
        .doSessionAxios(url, postD, "GET", "no login")
        .then((res) => {
          // this.isBuy = true;
          // this.$toast.success(this.$t("BUYBAR_LANG.buySuccess"));
          //TODO 下单成功，
          if (res.code == 0) {
            this.orderId = String(res.data.id);
            this.LOGIN2.getSession("no login")
            .then((session) => {
              var key = res.data.paydollarKeyEncrypt
              var ivKey = session.session.slice(0, 16)
              if(key && key.length>0){
                this.paydollar_key = Decrypt(key,ivKey,ivKey)
                this.signHashCode = this.signHash();
              }
              // console.log("this.orderId", this.orderId);
              if (res.data.totalFee == 0 || isFullCost) {
                let postData = {
                  rawData: res.data.productData,
                  statusCode: 0, //异常状态码
                  client: "h5",
                  type: this.payType,
                  result: "0", //0成功，1失败 2取消 -3状态异常
                  orderId: this.orderId,
                  msg: "使用积分优惠抵扣",
                };
                this.pay(postData);
              } else {
                this.openPay(this.payType);
              }
            })
          } else {
            this.UTILS.showFailToast(
              this.$t("BUY_LANG.buyFail") + "(" + res.message + ")"
            );
          }
        })
        .catch((err) => {
          this.UTILS.hideLoading();
          let msg = "";
          if (err.response && err.response.data) {
            msg = err.response.data.message;
          } else if (err.response && err.response.message) {
            msg = err.response.message;
          }
          this.UTILS.showFailToast(
            this.$t("BUY_LANG.buyFail") + "(" + msg + ")"
          );
        });
    },
    pay(result) {
      if (this.isBuy) {
        this.UTILS.showToast(this.$t("BUY_LANG.bought") + "了");
        return;
      }
      let postD = {
        data: JSON.stringify(result),
      };
      console.log(postD);
      this.GLOBAL_.ccRequest
        .doSessionAxios(this.CONFIG.H5BUY.PAY, postD, "POST")
        .then((res) => {
          this.isBuy = true;
          // console.log(res);
          this.UTILS.hideLoading();
          this.UTILS.showSuccessToast(this.$t("PAGE_HEADER_TITLE.buySuccess"));
          //跳转充值成功页
          this.goBuySuccess();
        })
        .catch((err) => {
          let errD = err.response.data;
          console.log("提交支付結果異常", errD.code, errD.message);
          this.UTILS.showToast(errD.message);
          this.UTILS.hideLoading();
          this.goBuyFail();
        });
    },
    payCancel(result) {
      let postD = {
        data: result,
      };
      this.GLOBAL_.ccRequest
        .doSessionAxios(this.CONFIG.H5BUY.CANCEL, postD, "POST")
        .then((res) => {
          //native.showToast(this.$t("RECHARGE_LANG.getIncrement"));
          this.UTILS.hideLoading();
        })
        .catch((err) => {
          this.UTILS.showToast(this.$t("RECHARGE_LANG.errPayMes"));
        });
    },
    goBuySuccess() {
      this.$router.replace({
        path: "/buySuccess",
        query: {
          columnCode: this.columnCode,
          id: this.id,
          objType: this.objType,
          orderId: this.orderId,
          reUrl: this.reUrl,
        },
      });
    },
    goBuyFail() {
      this.$router.replace({
        path: "/buyFail",
        query: {
          columnCode: this.columnCode,
          id: this.id,
          objType: this.objType,
          orderId: this.orderId,
          reUrl: this.reUrl,
        },
      });
    },
    //跳轉充值
    goRecharge() {
      //新窗口打开去充值
      let obj = {
        router: this.$router,
        path: this.UTILS.splitUrl("recharge"),
        isTransWindows: true,
      };
      this.GLOBAL_.ccApp.openTo(obj);
    },
    goPage(url) {
      window["prevWindowsParams"] = this.updateCoupon;
      this.GLOBAL_.routerHelper.goPage(url);
    },
    updateCoupon() {
      this.getData();
    },
    selectPay(type) {
      this.payType = type;
      this.createPayOrder(false);
    },
    openPay(type) {
      this.UTILS.hideLoading();
      this.selectPayDialog = false;
      if (type == "alipay") {
        // this.payMethod = 'ALIPAY'
        this.payMethod = "ALIPAYHKONL";
        this.paydollar();
      } else if (type == "CC") {
        this.payMethod = "CC";
        this.paydollar();
      } else if (type == "wechat") {
        if (this.isWechat()) {
          Dialog.alert({
            message: this.$t("PAGE_HEADER_TITLE.buyTips1"),
          }).then(() => {
            // on close
          });
        } else {
          this.payMethod = "WECHATONL";
          this.paydollar();
        }
      }
    },
    // 判断是否在微信环境
    isWechat() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf("micromessenger") !== -1;
    },
    getOrderCash() {
      return this.UTILS.formatPriceH5(this.realMoney);
      // return 0.01
    },
    signHash() {
      if (!this.paydollar_key) {
        return "";
      }
      const key = this.paydollar_key;
      const secureText =
        this.SERVER.PAYDOLLAR_METCHANT_ID +
        "|" +
        this.orderId +
        "|" +
        this.currencyCode +
        "|" +
        this.getOrderCash() +
        "|" +
        this.paymentType +
        "|" +
        key;
      const secureHash = SHA1(secureText);
      console.log("secureHash",secureHash,key);
      return secureHash;
    },
    paydollar() {
      let that = this;
      if (this.orderId && this.realMoney > 0) {
        console.log("orderId", this.orderId);
        // this.orderId = 23317692399
        this.showForm = true;
        this.$nextTick(() => {
          that.$refs.payMeForm.submit();
          setTimeout(() => {
            that.showForm = false;
          }, 500);
        });
      }
    },
    getPayMeCallbackUrl(urlType) {
      let action;
      let hostUrl = SERVER.HOST_PAGE_URL;
      let routerPath;
      if (urlType == "successUrl") {
        routerPath = "/buySuccess";
        action = "success";
      } else if (urlType == "cancelUrl") {
        routerPath = "/buyFail";
        action = "cancel";
      } else {
        routerPath = "/buyFail";
        action = "fail";
      }
      let queryParams =
        "?objType=" +
        this.objType +
        "&id=" +
        this.id +
        "&columnCode=" +
        this.columnCode +
        "&appid=" +
        this.SERVER.APPID +
        "&payType=" +
        this.payType +
        "&orderId=" +
        this.orderId +
        "&action=" +
        action +
        "&reUrl=" +
        this.reUrl;
      let url = hostUrl + routerPath + queryParams;
      // console.log(urlType, url);
      return url;
    },
    closeSelectPayDialog() {
      this.selectPayDialog = false;
    },
    onPaySuccess(payResult) {
      this.selectPayDialog = false;
      let postData = {
        rawData: null,
        statusCode: 0, //异常状态码
        client: "h5",
        type: this.payType,
        result: "0", //0成功，1失败 2取消 -3状态异常
        orderId: payResult.id,
        msg: "使用优惠抵扣成功",
      };
      this.pay(postData);
    },
    checkLogin() {
      this.LOGIN2.getSession("no login")
        .then((session) => {
          this.isLogin = true;
          this.getData();
        })
        .catch((err) => {
          this.isLogin = false;
          this.$dialog
            .confirm({
              message: this.$t("AUDIOPLAYERDE_LANG.shwoDialogLogin.1"),
              confirmButtonText: this.$t(
                "AUDIOPLAYERDE_LANG.shwoDialogLogin.2"
              ),
            })
            .then(() => {
              this.$router.push({
                path: "/login",
              });
            })
            .catch(() => {});
        });
    },
  },

  mounted() {
    console.log(this.$route.query);
    //从应用内跳转
    this.sign = this.$route.query.zSign || null;
    //从其他渠道挑战
    let onlySign = this.$route.query.sign || null;
    this.objType = this.$route.query.objType || null;
    this.id = this.$route.query.id || null;
    this.couponId = this.$route.query.couponId || null;
    this.reUrl = this.$route.query.reUrl || "";
    this.retry = this.$route.query.retry || 0;

    let thirdPartToken = this.$route.query.thirdPartToken || null;
    if (this.$route.query.appid) {
      this.SERVER.APPID = this.$route.query.appid;
    }
    if (this.SERVER.APPID == "boox" && !this.reUrl) {
      this.reUrl = document.referrer || "";
    }
    if (thirdPartToken && thirdPartToken != null) {
      this.LOGIN2.setThirdPartToken(thirdPartToken);
      console.log("========>購買third", thirdPartToken);
    }
    if (this.sign) {
      console.log("========>購買sign", this.sign);
      let sign = Decrypt(
        this.sign,
        process.env.aesPayKey,
        process.env.ivPayKey
      );
      if (sign) {
        let app_session = JSON.parse(sign);
        loginFun.saveLoginSession(app_session);
        this.isLogin = true;
        this.getData();
      } else {
        this.checkLogin();
      }
    } else if (onlySign) {
      console.log("========>購買onlySign", onlySign);
      let signSession = Decrypt(
        onlySign,
        process.env.aesPayKey,
        process.env.ivPayKey
      );
      // let session = Encrypt(onlySign,process.env.aesPayKey,process.env.ivPayKey)
      if (signSession) {
        let expireAt = new Date(Date.now() + 2592000000).getTime(); //30天 （1个月）
        let app_session = {
          expireAt: expireAt,
          session: signSession,
        };
        loginFun.saveLoginSession(app_session);
        this.isLogin = true;
        this.getData();
      } else {
        this.checkLogin();
      }
    } else {
      this.checkLogin();
    }
    // console.log('========>購買',document.referrer)
    // console.log("========>購買router", window.history.length);
    //判斷是否登錄
  },
  computed: {
    getOrderId: function () {
      return this.orderId;
    },
  },
  created() {},
};



// WEBPACK FOOTER //
// ./src/pages/buy/buy.vue